import { fromJS, Record } from 'immutable';
import { omitBy } from 'lodash';
import {
  generateKeys,
  generateSchema,
  hasValue,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { AddressData } from '../../geolocation-data/models/address-data.model';
import { IModelValidator } from '../../shared/interfaces/model-validator.interface';
import { Reference } from './reference.model';

export const BILLING_SCHEMA = Object.freeze({
  NAME: null, // ''
  EMAIL: null, // ''
  PHONE: null, // ''
  MOBILE: null, // ''
  ADDRESS: null, // ''
  ADDRESS_DATA: AddressData,
  REFERENCE: null, // Reference
});
const RECORD = generateSchema(BILLING_SCHEMA);
const KEYS: any = generateKeys(BILLING_SCHEMA);

export class Billing extends Record(RECORD) implements IModelValidator {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.REFERENCE,
        value: props.get(KEYS.REFERENCE) ? new Reference(this.reference) : null,
      },
      {
        key: KEYS.ADDRESS_DATA,
        value: props.get(KEYS.ADDRESS_DATA)
          ? new AddressData(this.addressData)
          : null,
      },
    ]);

    return selfModel as Billing;
  }

  get name(): string {
    return this.get(KEYS.NAME);
  }

  get email(): string {
    return this.get(KEYS.EMAIL);
  }

  get phone(): string {
    return this.get(KEYS.PHONE);
  }

  get mobile(): string {
    return this.get(KEYS.MOBILE);
  }

  get address(): string {
    return this.get(KEYS.ADDRESS);
  }

  get reference(): Reference {
    return this.get(KEYS.REFERENCE);
  }

  get referenceId(): string {
    return this.reference ? this.reference.id : '';
  }

  get addressData(): AddressData {
    return this.get(KEYS.ADDRESS_DATA);
  }

  hasValue(): boolean {
    const hasFieldsPopulated = hasValue(
      KEYS,
      omitBy(
        BILLING_SCHEMA,
        (_, key) => key.toLowerCase() === KEYS.REFERENCE.toLowerCase()
      ),
      this.toMap()
    );

    return (
      hasFieldsPopulated || (!!this.reference && this.reference.hasValue())
    );
  }
}
